import axios from 'axios'
import CreateEmail from './dto/CreateEmail'
import EmailSendResult from './dto/EmailSendResult'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/EmailProcess/Create`

export function onCreateEmail(createEmailFilter: CreateEmail): Promise<EmailSendResult> {
  return axios.post(URL_CREATE, createEmailFilter)
}
